import {Component, Injector} from '@angular/core';
import {BasePageComponent} from '@core-components/page-content/base-page.component';
import {UtilsService} from '@shared-services/utils.service';
import {LoadingService} from "@ui-kit/framework/util/service/loading.service";
import {PageHeaderTab} from "@core-components/page-header/page-header-tabs.interface";

@Component({
  selector: 'app-users-and-access',
  templateUrl: './users-and-access.component.html',
  styleUrls: ['./users-and-access.component.scss']
})
export class UsersAndAccessComponent extends BasePageComponent {

  tabs: PageHeaderTab[] = [
    {
      name: 'Groups',
      isActive: true,
      code: "rbac-groups"
    },
    {
      name: 'Roles',
      isActive: false,
      code: "rbac-roles"
    }
  ];

  activeTab: string = "run_payouts"

  constructor(injector: Injector, public utils: UtilsService, public loader: LoadingService) {
    super(injector);
  }

  changeTabs($event: PageHeaderTab): void {
    this.activeTab = $event.code;
  }

  getInitialTab(): PageHeaderTab {
    return this.tabs.at(0)!;
  }

  protected get offeringId(): string {
    return this.offering?.offeringUuid!;
  }

}
